export const ONUSERS = "ONUSERS";

export const ONPRODUCTS = "ONPRODUCTS";

export const ONALLPRODUCTS = "ONALLPRODUCTS";

export const ONPRODUCTVIEW = "ONPRODUCTVIEW";

export const ONPRODUCTEDIT = "ONPRODUCTEDIT";

export const ONPRODUCTADD = "ONPRODUCTADD";

export const ONPRODUCTDELET = "ONPRODUCTDELET";

export const ONCATEGORIESDELETE = "ONCATEGORIESDELETE";

export const ONCATEGORIES = "ONCATEGORIES";

export const ONCATEGORIESADD = "ONCATEGORIESADD";

export const ONCATEGORIESEDIT = "ONCATEGORIESEDIT";

export const ONSIZEGUIDE = "ONSIZEGUIDE";

export const ONSIZEGUIDEADD = "ONSIZEGUIDEADD";

export const ONSIZEGUIDEEDIT = "ONSIZEGUIDEEDIT";

export const ONSIZEGUIDEDELETE = "ONSIZEGUIDEDELETE";

export const ONOFFERS = "ONOFFERS";

export const ONOFFERSADD = "ONOFFERSADD";

export const ONOFFERSEDIT = "ONOFFERSEDIT";

export const ONOFFERSDELETE = "ONOFFERSDELETE";

export const ONALLORDERS = "ONALLORDERS";

export const ONCREATEROLE = "ONCREATEROLE";

export const ONALLROLE = "ONALLROLE";

export const ONEDITROLE = "ONEDITROLE";

export const ONDELETEROLE = "ONDELETEROLE";

export const ONADMINLOGIN = "ONADMINLOGIN";

export const ONALLADMIN = "ONALLADMIN";

export const ONEDITADMIN = "ONEDITADMIN";

export const ONDELETEADMIN = "ONDELETEADMIN";

export const ONCREATEADMIN = "ONCREATEADMIN";

export const ONADMINDETAIL = "ONADMINDETAIL";

export const ONSENDNOTIFICATION = "ONSENDNOTIFICATION";

export const DASHBOARD = "DASHBOARD";

export const BANNER = "BANNER";

export const BANNERADD = "BANNERADD";

export const BANNERDELETE = "BANNERDELETE";

export const CREATECATALOGDRAFT = "CREATECATALOGDRAFT";

export const CREATECATALOGGET = "CREATECATALOGGET";

export const CREATECATALOGUPDATE = "CREATECATALOGUPDATE";

export const CREATECATALOGDELETE = "CREATECATALOGDELETE";

export const CREATECATALOGPRODUCT = "CREATECATALOGPRODUCT";

export const UPLOADCATALOGIMAGE = "UPLOADCATALOGIMAGE";

export const DELETECATALOGIMAGE = "DELETECATALOGIMAGE";

export const ONCATALOGSUBMIT = "ONCATALOGSUBMIT";

export const ONCATALOGLIST = "ONCATALOGLIST";

export const ONCATALOGVIEW = "ONCATALOGVIEW";

export const ONLIVECATALOGPRODUCT = "ONLIVECATALOGPRODUCT";

export const ONCATEGORIESLIST = "ONCATEGORIESLIST";

export const CATALOGPRODUCTCLONE = "CATALOGPRODUCTCLONE";

export const CATALOGPRODUCTCLONELIST = "CATALOGPRODUCTCLONELIST";

export const ONCREATESHIPMENT = "ONCREATESHIPMENT";

export const ONCREATESHIPMENTLABEL = "ONCREATESHIPMENTLABEL";

export const ONDOWNLOADLABEL = "ONDOWNLOADLABEL";

export const ON_ORDER_DETAILS = "ON_ORDER_DETAILS";

export const GET_REFUNDS_SUCCESS = "GET_REFUNDS_SUCCESS";

export const REFUND_PROCESSING = "REFUND_PROCESSING";

export const REFUND_SUCCESS = "REFUND_SUCCESS";
